import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import { useNavigate } from 'react-router-dom'
import ProjectTechnologiesFilters from './componenets/ProjectTechnologiesFilters'
import ProjectTechnologiesTable from './componenets/ProjectTechnologiesTable'

const ProjectTechnologiesPage = () => {
  const navigate = useNavigate()

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Ключевые технологии</h2>
          </div>
          <div className='inline-flex-gap'>
            <Button theme='primary' onClick={() => navigate('/admin/project-technologies/create')}>
              <span className='inline-flex-gap' style={{ gap: '0.5em' }}>
                <span>+</span>
                <span>Создать</span>
              </span>
            </Button>
          </div>
        </div>
        <ProjectTechnologiesFilters />
        <ProjectTechnologiesTable />
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default ProjectTechnologiesPage
